import PasswordReset from './ResetPassword';
import './ResetPassword.scss';

export default PasswordReset
